<template>
  <div class="flex district-page">
    <!-- 左边 -->
    <div class="c_45 font_16 flex flex_col left">
      <!-- 上面的表单 -->
      <div class="selects">
        <div class="select-titles">查询信息</div>
        <el-form
          :model="queryParam"
          ref="ruleform"
          :inline="true"
          class="warnform-inline"
        >
          <el-form-item label="所在区域" class="form-item-noleft">
            <!-- <el-select v-model="queryParam.areaId" placeholder="请选择所在区域">
              <el-option
                v-for="(item, index) in areaSelect"
                :key="index"
                :value="item.id"
                :label="item.areaName"
              ></el-option>
            </el-select> -->
            <AreaCascader
              :key="AreaCascaderKey"
              :handleAreaData="handleAreaData"
              @selectArea="selectArea"
            ></AreaCascader>
          </el-form-item>

          <el-form-item label="产品类型">
            <el-select
              v-model="queryParam.productNameCode"
              placeholder="请选择产品类型"
              clearable
            >
              <el-option
                v-for="(item, index) in typeSelect"
                :key="index"
                :value="item.dictValue"
                :label="item.dictLabel"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号">
            <el-input
              placeholder="请输入产品型号"
              v-model="queryParam.productModelName"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品编号">
            <el-input
              placeholder="请输入产品编号"
              v-model="queryParam.deviceNum"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品名称" class="form-item-noleft">
            <el-input
              placeholder="请输入产品名称"
              v-model="queryParam.deviceName"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品状态">
            <el-select
              v-model="queryParam.onlineState"
              placeholder="请选择状态"
            >
              <el-option value="offline" label="离线"></el-option>
              <el-option value="online" label="在线"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称" class="">
            <el-input
              placeholder="请输入设备名称"
              v-model="queryParam.terminalName"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="产品归属">
						<el-select v-model="queryParam.productPattern" placeholder="请选择归属">
							<el-option :value="0" label="自有设备"></el-option>
							<el-option :value="1" label="他人共享"></el-option>
						</el-select>
					</el-form-item> -->
          <el-form-item class="el-form-item__content-btns">
            <div class="flex flex_ju_end form-btns">
              <el-button type="primary" class="btn-reset" @click="formReset"
                >重置</el-button
              >
              <el-button type="primary" @click="searchClick">查询</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 下面的表格 -->
      <div class="flex flex_col warn-tables">
        <!-- 关联区域按钮 -->
        <el-button :disabled = "!multipleSelection.length" class="btn-link" @click="handleLink">
          <img
            class="icon_link"
            src="@/assets/image/personal/icon_link.png"
            alt=""
          />
          <span>关联区域</span>
        </el-button>
        <!-- 表格 -->
        <el-table
          ref="multipleTable"
          :data="tableData"
          class="tables"
          :height="450"
          :stripe="true"
          align="center"
          header-cell-class-name="header-cell"
          cell-class-name="table-cell"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="60" align="right">
          </el-table-column>
          <el-table-column type="index" label="序号" width="100" align="center">
          </el-table-column>
          <el-table-column
            prop="terminalAreaFullName"
            label="所在区域"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="productName"
            label="产品类型"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="productCategoryName"
            label="产品型号"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="deviceName"
            label="产品名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="deviceNum"
            label="产品编号"
            width="210"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="terminalName"
            label="设备名称"
            width="210"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="产品状态"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.onlineState == 'online'">在线</span>
              <span v-else>离线</span>
            </template>
          </el-table-column>
          <!-- TODO 此版本没有共享功能，此显示隐藏 -->
          <!-- <el-table-column label="产品归属" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.productPattern == 0">自有设备</span>
							<span v-else class="attribution-share">他人共享</span>
						</template>
					</el-table-column> -->

          <!-- 占位数据 -->
          <div slot="empty" class="t_c table-empty">
            <img
              class="table-noimg"
              src="@/assets/image/personal/no_table.png"
              alt=""
            />
            <div class="table-emptyword">暂无设备数据</div>
          </div>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          class="pagination"
          layout="prev, pager, next"
          :current-page.sync="ipagination.currentPage"
          :page-size="ipagination.pageSize"
          :total="ipagination.total"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 右边-树形控件 -->
    <div class="right">
      <Tree
          ref="leftTree"
          :showAlter="showAlter"
          :multipleSelection="multipleSelection"
          @updateShow="updateShow"
          @changeAreaId="changeAreaId"
          @updateTreeData="updateTreeData"
          @draggableChangeEvent="draggableEvent"
          @loadData="loadData"
          @treeDataUpdate="treeDataUpdate"
        ></Tree>
    </div>
    
    <Msg ref="tsmsg"></Msg>
  </div>
</template>

<script>
/*
 * @description: 个人中心-区域管理
 */
import Msg from "@/components/msg.vue"; //信息提示组件
import tableMinin from "@/mixins/TableMinin";
import district from "./assets/distruct";
import Tree from "./components/tree.vue";
import AreaCascader from "@/components/AreaCascader.vue";
export default {
  mixins: [tableMinin, district],
  components: { Msg,Tree,AreaCascader },
  data() {
    const self = this;
    return {
      ipagination: {
        pageSize: 8,
        total: 0,
        currentPage: 1,
      },
      isLink: false, // 是否是关联区域状态
      areaSelect: [], // 区域下拉选
      typeSelect: [], // 产品类型型号下拉选
      queryParam: {
        // page: "1",
        // limit: "8",
        productNameCode: "",
        productModelName: "",
        deviceName: "",
        deviceNum: "",
        areaId: "",
        areaLevel:"",
        onlineState: "",
        terminalName:""
      },
      //树形组件数据
      treeData: [
        {
          id: "0",
          areaName: "全区域",
          sysUserId: "46",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "areaName",
      },
      // 存放树形组件的选中
      playIdObj: {},
      multipleSelection: [], // 批量选中数据
      radioLink: "", // 右侧树形关联区域时的选中值/id
      url: {
        list: self.$api.sysPageList,
        areaList: self.$api.sysAreaList,
        areaSave: self.$api.sysAreaSave,
        delArea: self.$api.sysAreaDel,
      },
      disableMixinCreated: true,
      ifUseLoadBack: false,
      isTranPage: true,
      pageValue: "page",
      pageLimit: "limit",


      showAlter: false,
      multipleSelectionAllot: [],
      handleAreaData: {},

      // 用于更新区域组件
      AreaCascaderKey:0,
    };
  },
  mounted() {
    this.getFirstArea();
    // this.loadAreaData();
    //  获取产品类型型号下拉选
    this.getTypeSelect();

    this.$nextTick(() => {
      this.loadData();
    });
  },
  methods: {
    // 所属区域
    selectArea(data) {
      console.log(data);
      this.queryParam.areaId = data.value;
      this.queryParam.areaLevel = data.data.areaLevel;
    },
    // 树形组件点击事件
    handleNodeClick(data) {
      // console.log(data);
      // 说明点击的是第一层，拦截点击事件
      if (data.children && data.children.length) return;
      // 此列表单选
      this.playIdObj = data;
    },
    // 表格选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 区域选中取消
      if (!val.length) {
        this.radioLink = "";
      }
    },
    // 关联区域点击
    handleLink() {
      // if (!this.isLink) {
      //   if (this.multipleSelection.length) {
      //     this.isLink = !this.isLink;
      //   } else {
      //     this.$message("暂无选中值", "warning");
      //   }
      // } else {
      //   this.isLink = false;
      //   this.$refs.multipleTable.clearSelection();
      //   this.radioLink = "";

      //   this.showAlter = true;
      // }
      this.showAlter = !this.showAlter;
    },
    // 关联确定
    handleLinkSubmit() {
      if (!this.radioLink || this.radioLink == "") {
        this.$message("请选择区域", "warning");
        return;
      }
      let multipleSelection = [];
      this.multipleSelection.forEach((item) => {
        multipleSelection.push(Number(item.deviceId));
      });
      let params = {
        deviceId: multipleSelection,
        areaId: this.radioLink,
      };
      // 请求关联接口
      this.$http.postAction(this.$api.sysAreaDeviceSave, params).then((res) => {
        if (res.code == 200) {
          this.$message("区域关联成功", "success");

          // 数据恢复
          setTimeout(() => {
            this.isLink = false;
            this.$refs.multipleTable.clearSelection();
            this.radioLink = "";
          }, 200);

          // 重新请求列表数据
          this.loadData(1);
        } else {
          this.$message(res.msg, "error");
        }
      });
    },

    /*
     * @description: 数据请求
     */
    // 获取table表格数据
    loadData(arg) {
      if (!this.url.list || this.url.list == "") {
        this.$message("请设置url.list!", "error");
        return;
      }

      if (arg == 1) {
        this.ipagination.currentPage = 1;
      }
      this.loading = true;
      // let params = Object.assign({}, this.queryParam);
      let params = this.getQueryParams()
      if (!params.areaId || params.areaId == "") {
        this.$set(params, "areaId", "0");
      }
      if (params.areaId=="0") {
        this.$set(params, "areaLevel", "");
      }
      this.$http
        .postAction(this.$api.userCtrlDeviceInfo, params)
        .then((res) => {
          if (res.code == 200) {
            let result = res.data || {};
            if (result.total > 0) { 
              let datas = result.records || [];
              this.tableData = datas || [];
              this.ipagination.total = Number(result.total);
            } else {
              this.tableData = [];
              this.ipagination.total = 0;
            }
          } else {
            this.tableData = [];
            this.ipagination.total = 0;
          }
        })
        .finally(() => {})
        .catch(() => {});
    },
    // 获取右侧区域数据
    loadAreaData() {
      if (!this.url.areaList || this.url.areaList == "") {
        this.$message("请设置url.areaList!", "error");
        return;
      }

      this.$http
        .getAction(this.url.areaList)
        .then((res) => {
          if (res.code == 200) {
            let datas = res.data || [];
            let treeData = [];
            this.areaSelect = datas;
            if (!datas.length) {
              treeData = [];
              this.$set(this.queryParam, "areaId", "");
            } else {
              // treeData = [...datas]
              // this.$set(this.queryParam, 'areaId', treeData[0]['id'])
              // treeData.forEach((item, index) => {
              // 	if (!item.children) {
              // 		this.$set(treeData[index], 'children', [])
              // 	}
              // })
              // 只有全区域
              if (datas.length == 1 && (datas[0]["areaName"] == "全区域" || datas[0]["areaName"] == "全部")) {
                treeData = [...datas];
                this.$set(treeData[0], "children", []);
              } else {
                treeData = [];
                // 有其它的区域
                let allIndex = datas.findIndex((item) => {
                  return item.id == "0" ;
                });
                let allItem = datas.slice(allIndex, 1)[0];
                this.$set(allItem, "children", []);
                let newDatas = [...datas];
                this.$delete(newDatas, allIndex);
                allItem.children = newDatas;
                treeData.push(allItem);
              }
            }
            this.$set(this.queryParam, "areaId", treeData[0]["id"]);
            this.treeData = treeData;
          } else {
            this.areaSelect = [];
          }
          console.log(this.treeData);
        })
        .finally((err) => {})
        .catch(() => {
          this.areaSelect = [];
        });
    },
    // 获取一级区域
    getFirstArea() {
      this.$http
        .postAction(this.$api.getSubAreaList+"?areaId=0").then((res) => {
          if (res.data) {
            this.treeData[0].children = res.data
          }
        })
      
    },
    // 获取产品类型型号下拉选
    getTypeSelect() {
      this.$http
        .getAction(this.$api.productNameModelList+"?type=1&deviceType=")
        .then((res) => {
          if (res.code == 200) {
            let datas = res.data || [];
            datas.forEach((item) => {
              item.dictValue = item.productNameCode
              item.dictLabel = item.productNameName
            })
            this.typeSelect = datas || [];
          } else {
            this.typeSelect = [];
          }
        })
        .catch(() => {
          this.typeSelect = [];
        });
    },
    // 重置点击
    formReset() {
      this.$refs["ruleform"].resetFields();
      this.queryParam = {
        // page: "1",
        // limit: "8",
        productNameCode: "",
        productModelName: "",
        deviceName: "",
        deviceNum: "",
        areaId: "",
        areaLevel:"",
        onlineState: "",
        terminalName:""
      };
      // if (this.areaSelect.length) {
      //   this.$set(this.queryParam, "areaId", this.areaSelect[0]["id"]);
      // } else {
      //   this.$set(this.queryParam, "areaId", "0");
      // }
      // 清空区域组件
      this.handleAreaData = { type: 0 };
      this.$nextTick(() => {
        this.loadData(1);
      });
    },


    // 接收子组件参数,关闭更改区域
    updateShow(val) {
      this.showAlter = val;
      this.showChangeAreaDia = false;
    },
    // 点击切换左侧树-区域,获取区域下列表
    changeAreaId(data) {
    },
    // 接收树形列表数据
    updateTreeData(val) {
      this.treeData = val;
    },
    // 区域排序功能开启关闭时
    draggableEvent(params) {
      this.isdraggable = params;
    },

    treeDataUpdate() {
      this.AreaCascaderKey++;
      // 重新加载区域级联选择
    }
  },
};
</script>

<style lang="scss">
@import "./assets/distruct.scss";
</style>
